import { ContextConsumer } from '@lit/context';
import { ApplicationContextToken } from '../application-context';
import { ApplicationContextInitializedError } from './lazy-app-context';
import { lazyValue } from './lazy-value';
class LazyConsumerError extends Error {
    constructor(host) {
        super(`Lazy consumer not initialized for ${host.tagName}`);
    }
}
export function lazyConsumer(host, options) {
    const context = new ContextConsumer(host, options);
    return lazyValue(() => new LazyConsumerError(host), () => context.value);
}
export function lazyAppContextConsumer(host) {
    const context = new ContextConsumer(host, { context: ApplicationContextToken, subscribe: true });
    return lazyValue(() => new ApplicationContextInitializedError(host.tagName), () => context.value);
}
//# sourceMappingURL=lazy-consumer.js.map